import React from "react"
import PropTypes from "prop-types"
//
import { Wrapper } from "./style"
import { slugify } from "../../utils"
import { css } from "emotion"
import { Marquee } from "../Marquee"
import { Container } from "../StyledComponents"
import { mq } from "../../styles/variables"

const getColor = (color) =>
  color !== "inherit"
    ? css`
        &,
        h1,
        h2,
        h3,
        h4,
        h5,
        h6,
        a:not(.btn) {
          color: ${color};
        }
      `
    : ""

export const ContentMarquee = ({
  className,
  adminclass,
  style,
  columnSpace,
  rowSpace,
  breakpoint,
  content,
  image,
  color,
  ...props
}) => (
  <Wrapper
    {...{
      "data-testid": "component-content-marquee",
      className:
        `${className} ${adminclass} ${getColor(color)} ` +
        css`
          margin-left: -30px;
          margin-right: -30px;

          ${mq.md(css`
            margin-left: -50px;
            margin-right: -50px;
          `)}

          ${mq.lg(css`
            margin-left: calc(calc(-100vw / 2 + 1120px / 2) + 7px);
            margin-right: calc(calc(-100vw / 2 + 1120px / 2) + 8px);
          `)}
        ` +
        " ",
      style,
      columnSpace,
      breakpoint,
      rowSpace,
      id: slugify(props.title) || ""
    }}
  >
    <Marquee image={image} className="">
      <Container>
        <div
          dangerouslySetInnerHTML={{ __html: content }}
          className={css`
            padding: 80px 0;
          `}
        />
      </Container>
    </Marquee>
  </Wrapper>
)

ContentMarquee.propTypes = {
  /** Vertical spacing base */
  rowSpace: PropTypes.number,
  /** Horizontal spacing base */
  columnSpace: PropTypes.number,
  /** Mobile first breakpoint */
  breakpoint: PropTypes.number,
  className: PropTypes.string,
  /** Secondary className. With WP/ACF, comes from the admin when content is created  */
  adminclass: PropTypes.string,
  style: PropTypes.object,
  /** HTML string (typically from a CMS), or a render prop */
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.func]).isRequired
}

ContentMarquee.defaultProps = {
  className: "",
  adminclass: "",
  style: {},
  rowSpace: 60,
  columnSpace: 30,
  breakpoint: 992
}



// WEBPACK FOOTER //
// /opt/build/repo/src/components/FlexibleContent/ContentMarquee.js